import { HttpClient } from './HttpClient.js';

export const HeaderService = {

    async getDataNotifications(dia,mes,anio,idU){
        return await HttpClient.get(`/notice/get-cancelled-agreements-yesterday/${dia}/${mes}/${anio}/${idU}`).then(response => response)
    },

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async changeStatus(idGestion){
        return await HttpClient.post('/notice/update-check-contact',idGestion).then(response => response);
    },

    async changeStatusNotices(idNotice){
        return await HttpClient.post('/notice/update-check-notice',idNotice).then(response => response);
    }

    
}